export interface SeonState {
  seonSession: string | null;
}

export function getInitialSeonState(): SeonState {
  return {
    seonSession: null,
  };
}
